import React, { Suspense } from 'react';

import { SettingsPageFrame, TableSkeleton } from '@eluve/blocks';
import {
  LinkButton,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@eluve/components';
import { useCaptureEventOnMount } from '@eluve/posthog-react';
import {
  useIsEluveAdmin,
  useIsPromptTemplateCreator,
} from '@eluve/session-helpers';

import { TenantOutputTemplatesList } from './TenantOutputTemplatesList';

export interface TenantOutputTemplatesListPageProps {}

export const TenantOutputTemplatesListPage: React.FC<
  TenantOutputTemplatesListPageProps
> = () => {
  useCaptureEventOnMount('page_view_output_templates_list');
  const isTemplateCreator = useIsPromptTemplateCreator();
  const isEluveAdmin = useIsEluveAdmin();

  const isCreateTemplateDisabled = !(isEluveAdmin || isTemplateCreator);

  return (
    <SettingsPageFrame
      size="wide"
      title="Templates"
      actions={
        <Tooltip>
          <TooltipTrigger asChild>
            <LinkButton
              to="create"
              size="sm"
              disabled={isCreateTemplateDisabled}
            >
              Create Template
            </LinkButton>
          </TooltipTrigger>
          {isCreateTemplateDisabled && (
            <TooltipContent>
              You do not have permission to create templates. Please contact
              your organizations administrator.
            </TooltipContent>
          )}
        </Tooltip>
      }
    >
      <Suspense fallback={<TableSkeleton rowCount={20} />}>
        <TenantOutputTemplatesList />
      </Suspense>
    </SettingsPageFrame>
  );
};
